export default __webpack_public_path__ + "static/media/book-cover24.8381b335.png";